import { Box } from '@mui/material'
import arrayMutators from 'final-form-arrays'
import { Form } from 'react-final-form'
import { CommitteeValues } from 'src/screens/shared/application/committee/ApplicationCommiteeUtils'
import { Option } from 'src/shared/form/control'
import { DirtyFormSpy } from 'src/shared/form/dirty/DirtyFormSpy'
import { createDecorators } from 'src/shared/form/utils/decorators'
import { PROCESS, PROCESS_TYPE } from 'src/shared/constants/constants'
import { PfKapCommitteeDecisions } from 'src/screens/pf-kap/application/committee/edit/PfKapCommitteeDecisions'
import { PfPgvCommitteeDecisions } from 'src/screens/pf-pgv/application/committee/edit/PfPgvCommitteeDecisions'

interface Props {
  process: PROCESS_TYPE
  locale: string
  initialValues: CommitteeValues | undefined
  exclusionCriteriaOptions: Option[]
  qualityCriteriaOptions: Option[]
  gfchResponsibleOptions: Option[]
  onSave: (values: CommitteeValues) => Promise<void>
}

export const CommitteeEditForm = ({
  process,
  locale,
  initialValues,
  qualityCriteriaOptions,
  exclusionCriteriaOptions,
  gfchResponsibleOptions,
  onSave,
}: Props) => {
  const decorators = createDecorators()
  return (
    <Box>
      <Form<CommitteeValues>
        onSubmit={onSave}
        mutators={{ ...arrayMutators }}
        initialValues={initialValues}
        decorators={decorators}
        render={({ handleSubmit, values }) => {
          return (
            <form id="committees-form" onSubmit={handleSubmit}>
              {process === PROCESS.PF_KAP && (
                <PfKapCommitteeDecisions
                  locale={locale}
                  values={values}
                  qualityCriteriaOptions={qualityCriteriaOptions}
                  exclusionCriteriaOptions={exclusionCriteriaOptions}
                  gfchResponsibleOptions={gfchResponsibleOptions}
                />
              )}

              {process === PROCESS.PF_PGV && (
                <PfPgvCommitteeDecisions
                  locale={locale}
                  values={values}
                  qualityCriteriaOptions={qualityCriteriaOptions}
                  exclusionCriteriaOptions={exclusionCriteriaOptions}
                  gfchResponsibleOptions={gfchResponsibleOptions}
                />
              )}
              <DirtyFormSpy />
            </form>
          )
        }}
      />
    </Box>
  )
}
